import React from 'react'

import { StyledTableCell, StyledTableRow } from '../../../components/EnchancedTable'
import { Revision, User, RevisionType } from '../../../types'
import moment from 'moment'
import { List, ListItem } from '@mui/material'

const revisionTypeToText: { [key in RevisionType]: string } = {
  ADD: 'Created',
  MOD: 'Modified',
  DEL: 'Deleted',
}

interface ModificationProps {
  changes: string[]
  state: User
}

const Modification: React.FC<ModificationProps> = ({ changes, state }) => {
  return (
    <List>
      {changes.map((change) => (
        <ListItem sx={{ alignItems: 'baseline' }}>
          Set {change} to{' '}
          <pre style={{ margin: 0, marginLeft: '1ex' }}>{JSON.stringify(state[change as keyof User], null, 2)}</pre>
        </ListItem>
      ))}
    </List>
  )
}

interface Props {
  state: User
  revision: Revision
}

const UserChangeRow: React.FC<Props> = ({ state, revision }) => {
  return (
    <StyledTableRow hover role="checkbox" tabIndex={-1} key={revision.rev}>
      <StyledTableCell>{moment(revision.createdAt).format('YYYY-MM-DD HH:mm:ss')}</StyledTableCell>

      <StyledTableCell>{revision.createdBy}</StyledTableCell>
      <StyledTableCell>
        {state.name} ({state.email})
      </StyledTableCell>

      <StyledTableCell>
        {revisionTypeToText[revision.type]}{' '}
        {revision.type === RevisionType.MOD && <Modification changes={revision.changes} state={state} />}
      </StyledTableCell>
    </StyledTableRow>
  )
}

export default UserChangeRow
